import capitalize from "lodash/capitalize";
import { propertyToTitle } from "PFCore/helpers/templates";
import { CustomTypes, Template } from "PFCore/types";

export const getFieldTitle = (
  fieldName: string,
  roleTemplate: Template,
  customTypes: CustomTypes,
  staticColumnNames: Record<string, string>
) =>
  propertyToTitle(roleTemplate, fieldName, customTypes) ??
  staticColumnNames[fieldName] ??
  capitalize(fieldName);
